export const SearchFormControlName = {
  Address: 'address',
};

export const SearchAddressControlValueProps = {
  Address: 'address',
  AddressId: 'addressId',
};
